module.exports = __webpack_public_path__ + "img/store.fe5b009a.svg";